module.exports = __webpack_public_path__ + "img/mail.1b212125.svg";